<div
    class="cmps-cdk-border-radius-4px cmps-cdk-bg-color-white cmps-uik-box-shadow-200 cmps-cdk-p-1 cmps-cdk-d-flex cmps-cdk-cg-1"
>
    <div class="cmps-cdk-flex-50">
        <div
            class="cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-cdk-font-bold cmps-cdk-color-grey-400"
        >
            Available Metrics
        </div>
        <div
            class="cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-h-256px cmps-cdk-max-h-256px cmps-cdk-overflow-hidden"
        >
            <div class="cmps-uik-box-shadow-200">
                <input
                    type="text"
                    class="cmps-cdk-border-width-0p cmps-cdk-px-0dot5 cmps-cdk-py-0dot25 cmps-cdk-w-100pct"
                    cmpsUikSearchInput
                    [placeholder]="'Search metrics...'"
                    [keyword]="_state.metricKeywords"
                    (keywordChange)="_onKeywordChange($event)"
                />
            </div>
            <div class="cmps-cdk-overflow-x-hidden cmps-cdk-overflow-y-auto">
                <ng-container
                    *ngFor="let m of _state.filteredMetrics; let last = last"
                >
                    <button
                        type="button"
                        class="cmps-cdk-bg-color-transparent cmps-cdk-border-b-color-grey-100 cmps-cdk-border-b-solid cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-flex cmps-cdk-p-0 cmps-cdk-text-left cmps-cdk-w-100pct focus:not:focus-visible:cmps-cdk-outline-none"
                        [class.cmps-cdk-border-b-width-1p]="!last"
                        [disabled]="_state.cannotSelectMetrics"
                        (click)="_onMetricClick(m)"
                        *ngIf="_state.viewParams.metricLookup?.[m.id] !== true"
                    >
                        <div
                            class="cmps-cdk-py-0dot25 cmps-cdk-px-0dot5 cmps-cdk-flex-grow-1"
                        >
                            {{ m.fullName }}
                        </div>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="cmps-cdk-flex-50">
        <div
            class="cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-cdk-font-bold cmps-cdk-color-grey-400"
        >
            Selected Metrics
        </div>
        <div
            class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-overflow-y-auto cmps-cdk-h-256px cmps-cdk-max-h-256px"
        >
            <ng-container
                *ngFor="
                    let m of _state.viewParams.metrics;
                    let first = first;
                    let last = last
                "
            >
                <div
                    class="cmps-cdk-border-b-color-grey-100 cmps-cdk-border-b-solid cmps-cdk-border-width-0p cmps-cdk-cg-0dot5 cmps-cdk-d-flex cmps-cdk-w-100pct cmps-cdk-px-0dot5"
                    [class.cmps-cdk-border-b-width-1p]="!last"
                >
                    <div class="cmps-cdk-py-0dot25 cmps-cdk-flex-grow-1">
                        {{ m.fullName }}
                    </div>
                    <div
                        class="cmps-cdk-align-items-center cmps-cdk-cg-0dot25 cmps-cdk-d-flex"
                    >
                        <div>
                            <button
                                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-p-0 focus:not:focus-visible:cmps-cdk-outline-none not:disabled:cmps-cdk-cursor-pointer"
                                [disabled]="first"
                                (click)="_onMoveUpClick(m)"
                            >
                                <cmps-icon svgIcon="arrow-up"></cmps-icon>
                            </button>
                        </div>

                        <div>
                            <button
                                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-p-0 focus:not:focus-visible:cmps-cdk-outline-none not:disabled:cmps-cdk-cursor-pointer"
                                [disabled]="last"
                                (click)="_onMoveDownClick(m)"
                            >
                                <cmps-icon svgIcon="arrow-down"></cmps-icon>
                            </button>
                        </div>

                        <div>
                            <button
                                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-p-0 focus:not:focus-visible:cmps-cdk-outline-none not:disabled:cmps-cdk-cursor-pointer"
                                (click)="_onRemoveClick(m)"
                            >
                                <cmps-icon
                                    class="cmps-cdk-color-red-100"
                                    svgIcon="close"
                                ></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
